import { faker } from '@faker-js/faker'

import { POLICY_TYPE } from '@hapana/shared/web/components/shared/core-user/user-access/components/add-edit-user-access.constants'

export const CORE_USER_MOCKED_RESPONSE = {
  id: faker.string.uuid(),
  v1Id: faker.string.uuid(),
  profile: {
    name: `${faker.person.firstName()} ${faker.person.lastName()}`,
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    email: faker.internet.email(),
    phone: faker.phone.number(),
    profileImage: `https://picsum.photos/200/200?random=${faker.number.int({ min: 1000, max: 9999 })}`,
    about: faker.lorem.paragraph(),
    hobbies: faker.lorem.words(5),
    instagramHandle: faker.internet.username(),
  },
  status: faker.helpers.arrayElement(['ACTIVE', 'INACTIVE']),
  access: {
    levels: new Array(3).fill().map(() => faker.person.jobTitle()),
    rules: [
      {
        id: faker.string.uuid(),
        accessPolicy: {
          id: faker.string.uuid(),
          name: faker.person.jobTitle(),
          type: POLICY_TYPE.BY_SITE,
          permissions: {
            access: [
              'READ_WRITE_POLICIES',
              'READ_WRITE_SITE_GROUPS',
              'READ_WRITE_USERS',
              'WRITE_ACCESS_RULES_TO_USERS',
            ],
            corporate: ['DOWNLOAD_EXPORTS', 'READ_WRITE_CONTROLS'],
            site: [],
          },
        },
        type: POLICY_TYPE.BY_SITE,
        sites: [
          { id: '64397337cc14ccaeac8688c7', name: 'EW dev1' },
          { id: '64397337cc14ccaeac868951', name: 'KX Location 5' },
        ],
        siteGroups: [
          { id: '6732626a3a60a3171b0cdf1b', name: 'him second three' },
          { id: '6732626b3a60a3171b0cdf21', name: 'new' },
        ],
        isAllSites: false,
      },
    ],
  },
}

export const CORE_USERS_MOCKED_RESPONSE = {
  coreUsers: {
    results: new Array(3).fill().map(() => ({
      node: {
        ...CORE_USER_MOCKED_RESPONSE,
      },
    })),
    pageInfo: {
      startCursor: faker.string.uuid(),
      endCursor: faker.string.uuid(),
      totalRecords: faker.number.int(),
      hasNextPage: true,
    },
  },
}

export const CORE_CREATE_USER_MOCKED_RESPONSE = {
  createCoreUser: {
    id: faker.string.uuid(),
  },
}

export const CORE_SET_USER_DATA_RESPONSE = {
  setCoreUserData: {
    id: faker.string.uuid(),
  },
}

export const CORE_UPDATE_USER_MOCKED_RESPONSE = {
  updateCoreUser: {
    id: faker.string.uuid(),
  },
}

export const CORE_CHANGE_PASSWORD_MOCKED_RESPONSE = {
  changeCoreUserPassword: {
    id: faker.string.uuid(),
  },
}

export const CORE_RESEND_WELCOME_EMAIL_MOCKED_RESPONSE = {
  resendCoreUserWelcomeEmail: {
    id: faker.string.uuid(),
  },
}

export const CORE_CHANGE_STATUS_MOCKED_RESPONSE = {
  changeCoreUserStatus: {
    id: faker.string.uuid(),
    status: faker.helpers.arrayElement(['ACTIVE', 'INACTIVE']),
  },
}

export const AVAILABLE_SITES_MOCKED_RESPONSE = {
  availableToAssignSites: {
    results: new Array(5).fill().map(() => ({
      node: {
        id: faker.string.uuid(),
        name: faker.company.name(),
      },
    })),
  },
}

export const ACCESS_POLICIES_MOCKED_RESPONSE = {
  accessPolicies: new Array(5).fill().map(() => ({
    id: faker.string.uuid(),
    name: faker.company.name(),
  })),
}

export const SITE_GROUPS_MOCKED_RESPONSE = {
  siteGroups: {
    results: new Array(5).fill().map(() => ({
      node: {
        id: faker.string.uuid(),
        name: faker.company.name(),
      },
    })),
  },
}

export const SITES_MOCKED_RESPONSE = {
  sites: {
    results: new Array(5).fill().map(() => ({
      node: {
        id: faker.string.uuid(),
        name: faker.company.name(),
      },
    })),
  },
}

export const AVAILABLE_TO_ASSIGN_ACCESS_POLICIES_MOCKED_RESPONSE = {
  availableToAssignAccessPolicies: {
    results: new Array(5).fill().map(() => ({
      node: {
        id: faker.string.uuid(),
        name: faker.company.name() + ' Policy',
      },
    })),
  },
}
